import { IEnumToggleProp } from 'helpers/type';
import { AppConfig } from 'configs/type';

const FEATURE_TOGGLES: IEnumToggleProp<boolean> = {
    LOAD_REDUX_DEVTOOLS: true,
    FEATURE_PRODUCT_MANAGEMENT: true,
    FEATURE_CHECKOUT_ACTIONS: true,
    FEATURE_SSP_ACTIONS: true,
    FEATURE_AVOID_INVALID_ERROR_TRACK: true,
};

const config: AppConfig = {
    AUTHENTICATION_AUTHORITY: 'https://sit.login.myob.com',
    AUTHENTICATION_WEB_CLIENT_ID: 'self-service-portal-web',
    AUTHENTICATION_BFF_CLIENT_ID: 'self-service-portal-bff',
    SEGMENT_WRITE_KEY: '', // Removed key for local environment to save Monthly Tracked Users
    FEATURE_TOGGLES,
    API_BASE_URL: 'https://products-mf.sit.myaccount.myob.com',
};

export default config;
